var _path, _path2, _path3, _path4, _path5;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDailyLoginReward(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.067 12.0986H7.76725C6.69387 12.0986 5.82373 12.9688 5.82373 14.0421V19.0564C5.82373 20.1298 6.69387 20.9999 7.76725 20.9999H17.067C18.1404 20.9999 19.0105 20.1298 19.0105 19.0564V14.0421C19.0105 12.9688 18.1404 12.0986 17.067 12.0986Z",
    stroke: "#ACACB4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5644 6.11386L6.29624 8.61981C5.37405 8.86916 4.8286 9.81887 5.07794 10.7411C5.32729 11.6632 6.277 12.2087 7.19919 11.9594L16.4674 9.4534C17.3895 9.20406 17.935 8.25435 17.6856 7.33216C17.4363 6.40997 16.4866 5.86452 15.5644 6.11386Z",
    stroke: "#ACACB4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36914 4.01803C9.25093 3.77961 10.1566 4.29978 10.3951 5.18157L10.8262 6.7763L9.23151 7.20748C8.34972 7.4459 7.44402 6.92573 7.2056 6.04394C6.96718 5.16215 7.48735 4.25645 8.36914 4.01803V4.01803Z",
    stroke: "#ACACB4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4189 6.34915L10.8242 6.78034L10.393 5.18562C10.1546 4.30383 10.6748 3.39813 11.5566 3.1597C12.4384 2.92128 13.3441 3.44146 13.5825 4.32324C13.8209 5.20503 13.3007 6.11073 12.4189 6.34915Z",
    stroke: "#ACACB4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4038 12.3496V20.6879",
    stroke: "#ACACB4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDailyLoginReward);
export default __webpack_public_path__ + "static/media/icon_daily_login_reward.65a14b84519c459e75c515c42d82f2f0.svg";
export { ForwardRef as ReactComponent };